// Schedule side lineup boards: how wide each side gutter is for this window (viewport px).
// Full desktop (≥1280): fixed gutters. Half-screen desktop windows (768–1279, mouse/trackpad):
// narrower gutters while a game is open, so the side lineups still show instead of Summary | Lineups tabs.
export const isDesktopPointer = () => typeof window !== "undefined" && !window.matchMedia("(pointer: coarse)").matches;
export function sideGutterVp(W, hasOpen) {
    if (W >= 1280) return Math.min(440, Math.max(300, W * 0.2));
    if (W >= 768 && hasOpen && isDesktopPointer()) return Math.min(300, Math.max(200, W * 0.24));
    return 0;
}
export const sideBoardsFit = (W) => W >= 1280 || (W >= 768 && isDesktopPointer());
// Card columns from the width the cards actually get.
export const colsForWidth = (vis) => (vis >= 1250 ? 5 : vis >= 860 ? 4 : vis >= 600 ? 3 : vis >= 380 ? 2 : 1);
